export const NAV_ITEMS = [
  { path: "/log", label: "Historique" },
  { path: "/examiner", label: "Examinateurs" },
  { path: "/student", label: "Élèves" },
  { path: "/group", label: "Groupes" },
  { path: "/summary", label: "Récapitulatif" },
  { path: "/admin", label: "Administrateur" },
];
